/**
 * BOGO Promotion Component
 */
class BogoPromotion extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = null;
  }

  connectedCallback() {
    //this.setupBogoQualification();
    this.subscribeToCartUpdates();
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }
  renderBogoBlock() {
    const sectionId = this.closest('[data-section-id]')?.dataset.sectionId;

    if (!sectionId) return;

    fetch(`${window.location.pathname}?section_id=${sectionId}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newBlock = parser.parseFromString(html, 'text/html').querySelector('[data-bogo-promotion]');
        const currentBlock = document.querySelector('[data-bogo-promotion]');
       
        
        if (newBlock && currentBlock) {
          if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.viewTransition) {
            HTMLUpdateUtility.viewTransition(currentBlock, newBlock);
          } else {
            currentBlock.innerHTML = newBlock.innerHTML;
          }
        }
      })
      .catch(error => console.error('BOGO: Render failed:', error));
  }
  setupBogoQualification() {
    
   
    const bogoScript = document.querySelector('script[data-bogo-item]');
     
    if (!bogoScript) return;
  
    
    try {
      const itemData = JSON.parse(bogoScript.textContent);
      itemData.properties = Array.isArray(itemData.properties) 
          ? itemData.properties.reduce((acc, [key, value]) => (acc[key] = value, acc), {})
          : itemData.properties || {};
      
      if (itemData && !itemData.properties?.['_bogo_qualified']) {
        
      
        itemData.properties['_bogo_qualified'] = 'true';
       
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: itemData.id,
            quantity: itemData.quantity,
            properties: itemData.properties
          })
        
          
        })
        .then(res => res.json())
  .then(cart => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bogo-promotion',
        cart
      });
    }
  })
  .catch(error => {
          console.error('BOGO: Cart change error:', error);
        });
      }
    } catch (error) {
      console.error('BOGO: Qualification failed:', error);
    }
  }

  subscribeToCartUpdates() {
    const isCartPage = window.location.pathname.startsWith('/cart');

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {

        if (event.source !== 'bogo-promotion' && !isCartPage) {
          this.renderBogoBlock();
        }
      });
    }
  }

  

  refresh() {
    this.renderBogoBlock();
  }
}

customElements.define('bogo-promotion', BogoPromotion); 